import { render, staticRenderFns } from "./dialogNoticeIp.vue?vue&type=template&id=2cb8d20f&scoped=true&"
import script from "./dialogNoticeIp.vue?vue&type=script&lang=js&"
export * from "./dialogNoticeIp.vue?vue&type=script&lang=js&"
import style0 from "./dialogNoticeIp.vue?vue&type=style&index=0&id=2cb8d20f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb8d20f",
  null
  
)

export default component.exports